import { setOpenPopupData } from 'actions/damActions';
import {
  CLOSE_OPEN_POPUP,
  INNER_FOLDER_UPDATE_DETAILS,
  INNER_PREV_SELECTED,
  SET_HIERARCHY_FOLDER_DATA,
  SET_INSIDE_FOLDER_DATA,
  SET_INSIDE_FOLDER_FOLDER_DATA,
  SET_INSIDE_FOLDER_ID,
  SET_OPEN_POPUP_DAM,
  SET_SELECT_ASSET_DATA,
  SET_SELECT_FOLDER_DATA,
} from 'actions/types';

const initialState = {
  open: false,
  isInsideFolder: true,
  data: {},
  insideFolderData: [],
  insideFolderId: null,
  insideFolderFolderData: {
    folders: [],
    images: [],
  },
  selectedFolders: [],
  selectedAssets: [],
  HierarchyFolderData: [],
  InnerFolderDetails: {},
  indexSelected: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_POPUP_DAM:
      return {
        ...state,
        open: true,
        data: action.payload,
      }; //CLOSE_OPEN_POPUP
    case CLOSE_OPEN_POPUP:
      return {
        ...state,
        open: false,
      };
    case SET_INSIDE_FOLDER_DATA:
      return {
        ...state,
        isInsideFolder: action.payload,
      };
    case SET_INSIDE_FOLDER_ID:
      return {
        ...state,
        insideFolderId: action.payload,
      };
    case SET_INSIDE_FOLDER_FOLDER_DATA:
      return {
        ...state,
        insideFolderFolderData: action.payload,
      };
    case SET_SELECT_FOLDER_DATA:
      return {
        ...state,
        selectedFolders: action.payload,
      };
    case SET_SELECT_ASSET_DATA:
      return {
        ...state,
        selectedAssets: action.payload,
      };
    case SET_HIERARCHY_FOLDER_DATA:
      return {
        ...state,
        HierarchyFolderData: action.payload,
      };
    case INNER_FOLDER_UPDATE_DETAILS:
      return {
        ...state,
        InnerFolderDetails: action.payload,
      };
    case INNER_PREV_SELECTED:
      return {
        ...state,
        indexSelected: action.payload,
      };
    case setOpenPopupData:
      return {
        ...state,
      };
    default:
      return state;
  }
};
